<template>
  <div style="padding: 2vh 1.5vw;">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>广播</el-breadcrumb-item>
            <el-breadcrumb-item>广播设备任务</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="text-align: right;margin: 2vh 0;">
        <el-button type="warning" @click="openRealTimeDialog = true">实时播放</el-button>
        <el-button type="primary" @click="openDialog">添加任务</el-button>
      </el-col>
    </el-row>

    <el-card>
      <el-table stripe :data="tableData" style="width: 100%;" height='65vh'>
        <el-table-column label="序号" type="index" :index="indexMethod" width="80">
        </el-table-column>
        <el-table-column prop="imei" label="设备号" width="120">
        </el-table-column>
        <el-table-column label="任务名称" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.playTag == '1'">无</span>
            <span v-if="scope.row.playTag == '2'">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="播放次数" width="100">
        </el-table-column>
        <el-table-column prop="volume" label="音量" width="100">
        </el-table-column>
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">
            <p v-if="scope.row.type == 1">手动</p>
            <p v-if="scope.row.type == 2">定时</p>
            <p v-if="scope.row.type == 3">实时</p>
          </template>
        </el-table-column>
        <el-table-column label="播放形式" width="100">
          <template slot-scope="scope">
            <p v-if="scope.row.playTag == 1" style="color: #f86b1d;">文件播放</p>
            <p v-if="scope.row.playTag == 2" style="color: #fecc11;">文字播放</p>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <p v-if="scope.row.status == 0">未开始</p>
            <p v-if="scope.row.status == 1" style="color: #2bae85;">正在播放</p>
            <p v-if="scope.row.status == 2" style="color: red;">暂停</p>
          </template>
        </el-table-column>
        <el-table-column label="播放内容" width="120">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.name" placement="top">
              <span class="line2" v-if="scope.row.playTag == '1'">{{ scope.row.name }}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :content="scope.row.content" placement="top">
              <span class="line2" v-if="scope.row.playTag == '2'">{{ scope.row.content }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="weeks" label="周期规则">
          <template slot-scope="scope" v-if="scope.row.weeks">
            <span v-if="scope.row.weeks.indexOf(0)>=0" style="margin-right: 5px;">每天</span>
            <span v-if="scope.row.weeks.indexOf(1)>=0" style="margin-right: 5px;">星期一</span>
            <span v-if="scope.row.weeks.indexOf(2)>=0" style="margin-right: 5px;">星期二</span>
            <span v-if="scope.row.weeks.indexOf(3)>=0" style="margin-right: 5px;">星期三</span>
            <span v-if="scope.row.weeks.indexOf(4)>=0" style="margin-right: 5px;">星期四</span>
            <span v-if="scope.row.weeks.indexOf(5)>=0" style="margin-right: 5px;">星期五</span>
            <span v-if="scope.row.weeks.indexOf(6)>=0" style="margin-right: 5px;">星期六</span>
            <span v-if="scope.row.weeks.indexOf(7)>=0" style="margin-right: 5px;">星期日</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button icon="el-icon-check" type="text" @click="executeTask(scope.row.id)">执行任务</el-button>
            <el-button icon="el-icon-close" type="text" @click="stopTask(scope.row.id)">停止任务</el-button>
            <el-button icon="el-icon-video-play" type="text" @click="openTask(scope.row)">开启任务</el-button>
            <el-button icon="el-icon-video-pause" type="text" @click="pauseTask(scope.row)">暂停任务</el-button>
            <el-button icon="el-icon-edit" type="text" :disabled="scope.row.type == 3" @click="updateTask(scope.row)">修改任务</el-button>
            <el-button icon="el-icon-delete" type="text" @click="deleteTask(scope.row.id)">删除任务</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="1"
        :page-sizes="[5, 10, 20, 50]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 添加任务弹出框 -->
    <el-dialog title="添加任务" :visible.sync="adddialogVisible" width="40%">

      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="任务名称">
          <el-input v-model="form.name" placeholder="请输入任务名称" style="width: 60%;"></el-input>
        </el-form-item>
        <el-form-item label="音量">
          <el-slider v-model="form.volume" style="width: 60%;"></el-slider>
        </el-form-item>
        <el-form-item label="播放次数">
          <el-input-number v-model="form.count" :min="1" size="small" style="display: block;"></el-input-number>
        </el-form-item>
        <el-form-item label="周期规则">
          <el-checkbox-group v-model="checkedWeeks" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="week in weeks" :label="week" :key="week">{{week}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select v-model="form.type" placeholder="请选择任务类型" @change="isType">
            <el-option label="手动" value="1"></el-option>
            <el-option label="自动" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="播放形式">
          <el-select v-model="form.playTag" placeholder="请选择播放形式">
            <el-option label="文件播放" value="1"></el-option>
            <el-option label="文字播放" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件" v-show="form.playTag == 1">
          <input type="file" accept=".mp3" @change="inputFileChange" ref="clearfile">
        </el-form-item>
        <el-form-item label="文字" v-show="form.playTag == 2">
          <el-input type="textarea" v-model="form.content" placeholder="请输入要播放的文字" style="width: 60%;"></el-input>
        </el-form-item>
        <el-form-item label="声音信息" v-show="form.playTag == 2">
          <el-select v-model="form.per" placeholder="请选择播放形式">
            <el-option v-for="voice in voiceList" :label="voice.name" :value="voice.id" :key="voice.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间" v-show="isShow">
          <el-date-picker v-model="time" type="datetimerange" unlink-panels range-separator="-" @change="change"
            value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="adddialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTask">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 实时播放广播弹出框 -->
    <el-dialog title="添加实时播放" :visible.sync="openRealTimeDialog" width="40%">

      <el-form :model="realTimeForm" label-width="80px">
        <el-form-item label="音量">
          <el-slider v-model="realTimeForm.volume" style="width: 60%;"></el-slider>
        </el-form-item>
        <el-form-item label="播放次数">
          <el-input-number v-model="realTimeForm.count" :min="1" size="small" style="display: block;"></el-input-number>
        </el-form-item>
        <el-form-item label="播放形式">
          <el-select v-model="realTimeForm.playTag" placeholder="请选择播放形式">
            <el-option label="文件播放" value="1"></el-option>
            <el-option label="文字播放" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件" v-show="realTimeForm.playTag == 1">
          <input type="file" accept=".mp3" @change="inputFileRealTimeChange" ref="clearfile">
        </el-form-item>
        <el-form-item label="文字" v-show="realTimeForm.playTag == 2">
          <el-input type="textarea" v-model="realTimeForm.content" placeholder="请输入要播放的文字" style="width: 60%;">
          </el-input>
        </el-form-item>
        <el-form-item label="声音信息" v-show="realTimeForm.playTag == 2">
          <el-select v-model="realTimeForm.per">
            <el-option v-for="voice in voiceList" :label="voice.name" :value="voice.id" :key="voice.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="openRealTimeDialog = false">取 消</el-button>
        <el-button type="primary" @click="addRealTime">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改任务弹出框 -->
    <el-dialog title="修改任务" :visible.sync="updateDialogVisible" width="40%">

      <el-form ref="updateForm" :model="updateForm" label-width="80px">
        <el-form-item label="任务名称" v-show="updateForm.type != 3">
          <el-input v-model="updateForm.name" placeholder="请输入任务名称" style="width: 60%;"></el-input>
        </el-form-item>
        <el-form-item label="音量">
          <el-slider v-model="updateForm.volume" style="width: 60%;"></el-slider>
        </el-form-item>
        <el-form-item label="播放次数">
          <el-input-number v-model="updateForm.count" :min="1" size="small" style="display: block;"></el-input-number>
        </el-form-item>
        <el-form-item label="周期规则" v-show="updateForm.type != 3">
          <el-checkbox-group v-model="checkedWeeks" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="week in weeks" :label="week" :key="week">{{week}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="任务类型" v-show="updateForm.type != 3">
          <el-select v-model="updateForm.type" placeholder="请选择任务类型">
            <el-option label="手动" value="1"></el-option>
            <el-option label="自动" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="播放形式">
          <el-select v-model="updateForm.playTag" placeholder="请选择播放形式">
            <el-option label="文件播放" value="1"></el-option>
            <el-option label="文字播放" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文字" v-show="updateForm.playTag == 2">
          <el-input type="textarea" v-model="updateForm.content" placeholder="请输入要播放的文字" style="width: 60%;"></el-input>
        </el-form-item>
        <el-form-item label="声音信息" v-show="updateForm.playTag == 2">
          <el-select v-model="updateForm.per">
            <el-option v-for="voice in voiceList" :label="voice.name" :value="voice.id" :key="voice.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件" v-show="updateForm.playTag == 1">
          <input type="file" accept=".mp3" @change="inputFileChange2" ref="clearfile2">
        </el-form-item>
        <el-form-item label="时间" v-show="updateForm.type == 2">
          <el-date-picker v-model="time" type="datetimerange" unlink-panels range-separator="-" @change="change"
            value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateTaskSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import myHttp from '../untils/port.js'
  import util from '../untils/util.js'
  const weekOptions = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
  export default {
    data() {
      return {
        voiceList: [],
        isShow: false,
        total: 0,
        pageNum: 1,
        pageSize: 10,
        tableData: [],
        adddialogVisible: false,
        updateDialogVisible: false,
        openRealTimeDialog: false,
        form: {
          name: '',
          volume: 0,
          count: 1,
          type: '',
          file: '',  //文件
          content: '',  //文字内容
          playTag: '',  //播放形式
          per: ''   //声音信息
        },
        realTimeForm: {     //实时播放
          volume: 0,
          count: 0,
          file: '',
          playTag: '',
          per: '',
          content: ''
        },
        updateForm: {
          name: '',
          volume: 0,
          count: 1,
          type: 0,
          file: '',
          playTag: '',
          content: '',
          per: '',
          id: ''     //任务id
        },
        checkAll: false,
        checkedWeeks: [],
        weeks: weekOptions,
        isIndeterminate: false,
        newWeek: '',
        beginDate: '',   //开始时间
        finishDate: '',   //结束时间
        time: ''
      }
    },
    created() {
      this.getbroadcastTask();
      this.getVoiceList();
    },
    methods: {
      //获取声音信息
      getVoiceList() {
        myHttp.getVoiceList().then(resp => {
          console.log(resp);
          if (resp.data.code == '200') {
            this.voiceList = resp.data.data.voiceList
          }
        })
      },
      //获取广播任务
      getbroadcastTask() {
        myHttp.getBroadcastTask({
          imei: this.$route.query.id,
          name: '',
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then(resp => {
          console.log(resp);
          if (resp.data.code == '200') {
            this.tableData = resp.data.data.broadcastJblingTask.list
            this.total = resp.data.data.broadcastJblingTask.total
          }
        })
      },
      openDialog() {
        this.checkedWeeks = []
        this.adddialogVisible = true
      },
      //添加广播任务
      addbroadcastTask() {
        console.log(this.form.file);
        // if (this.form.file) {
        // 把文件放入FormData
        let fd = new FormData();
        fd.append("file", this.form.file);
        fd.append("name", this.form.name)
        fd.append('imei', this.$route.query.id)
        fd.append('volume', this.form.volume)
        fd.append('count', this.form.count)
        fd.append('weeks', this.newWeek)
        fd.append('type', this.form.type)
        fd.append('beginDate', this.beginDate)
        fd.append('finishDate', this.finishDate)
        fd.append('content', this.form.content)
        fd.append('playTag', this.form.playTag)
        fd.append('per', this.form.per)
        console.log(this.checkedWeeks);
        myHttp.addBroadcastTask(fd).then(resp => {
          console.log(resp);
          if (resp.data.code == '200') {
            this.$message({
              message: '添加任务成功',
              type: 'success'
            })
            this.checkedWeeks = []
            this.form.name = ''
            this.form.volume = 0
            this.form.count = 1
            this.form.type = ''
            this.$refs.clearfile.value = null
            this.adddialogVisible = false
            this.getbroadcastTask();
          } else {
            this.$message({
              message: resp.data.msg,
              type: 'error'
            })
          }

        })
        // } else {
        //   this.$message({
        //     message: '请选择文件',
        //     type: 'error'
        //   })
        // }

      },
      inputFileChange(e) {
        // input的@change事件拿到数据        
        this.form.file = e.target.files[0]
      },
      //开启任务
      openTask(data) {
        if (data.status == 2) {
          myHttp.openBroadcastTask({
            id: data.id
          }).then(resp => {
            console.log(resp);
            if (resp.data.code == '200') {
              this.$message({
                message: '开启任务成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: resp.data.msg,
                type: 'error'
              })
            }
            this.getbroadcastTask();
          })
        } else {
          this.$message({
            message: '必须先暂停任务',
            type: 'error'
          })
        }

      },
      //执行任务
      executeTask(id) {
        myHttp.executeBroadcastTask({
          id: id
        }).then(resp => {
          console.log(resp);
          if (resp.data.code == '200') {
            this.$message({
              message: '执行任务成功',
              type: 'success'
            });
            this.getbroadcastTask();
          } else {
            this.$message({
              message: resp.data.msg,
              type: 'error'
            })
          }
        })
      },
      //停止任务
      stopTask(id) {
        myHttp.stopBroadcastTask({
          id
        }).then(resp => {
          console.log(resp);
          if (resp.data.code == '200') {
            this.$message({
              message: '停止任务成功',
              type: 'success'
            });
            this.getbroadcastTask();

          }
        })
      },
      // 暂停任务
      pauseTask(data) {
        if (data.status == 1) {
          myHttp.pauseBroadcastTask({
            id: data.id
          }).then(resp => {
            console.log(resp);
            if (resp.data.code == '200') {
              this.$message({
                message: '暂停任务成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: resp.data.msg,
                type: 'error'
              })
            }
            this.getbroadcastTask();
          })
        }
        else {
          this.$message({
            message: '必须先执行任务',
            type: 'error'
          })
        }

      },
      //判断任务类型
      isType(val) {
        if (val == 2) {
          this.isShow = true
        } else {
          this.isShow = false
        }
      },
      change(value) {
        this.time = value
        this.beginDate = value[0]
        this.finishDate = value[1]
      },
      //  上传
      success(resp, file) {
        if (resp.code == '200') {
          this.annexAddresses = file.raw
        } else {
          this.$message.error(res.msg)
        }
      },
      // 添加任务
      addTask() {
        this.addbroadcastTask();
      },
      // 修改任务
      updateTask(data) {
        this.updateForm.id = data.id
        this.updateForm.type = data.type
        this.updateForm.playTag = data.playTag
        this.checkedWeeks = []
        let allTime = []
        allTime.push(data.beginDate)
        allTime.push(data.endDate)
        this.time = allTime
        if (data.status == 1 || data.status == 2) {
          this.$message({
            message: '任务在运行或暂停时不允许修改',
            type: 'error'
          })
          return false
        }
        this.updateForm = JSON.parse(JSON.stringify(data))
        if (this.updateForm.weeks) {
          if (this.updateForm.weeks.indexOf(0) >= 0) {
            this.checkedWeeks = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
          }
          if (this.updateForm.weeks.indexOf(1) >= 0) {
            this.checkedWeeks.push('星期一')
          }
          if (this.updateForm.weeks.indexOf(2) >= 0) {
            this.checkedWeeks.push('星期二')
          }
          if (this.updateForm.weeks.indexOf(3) >= 0) {
            this.checkedWeeks.push('星期三')
          }
          if (this.updateForm.weeks.indexOf(4) >= 0) {
            this.checkedWeeks.push('星期四')
          }
          if (this.updateForm.weeks.indexOf(5) >= 0) {
            this.checkedWeeks.push('星期五')
          }
          if (this.updateForm.weeks.indexOf(6) >= 0) {
            this.checkedWeeks.push('星期六')
          }
          if (this.updateForm.weeks.indexOf(7) >= 0) {
            this.checkedWeeks.push('星期日')
          }
        }
        this.updateDialogVisible = true;
      },
      //  删除任务
      deleteTask(id) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteTask({
            id: id
          }).then(resp => {
            console.log(resp);
            if( resp.data.code == '200' ) {
              this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getbroadcastTask()
            }
          })
        
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      
      updateTaskSubmit() {
        // if (this.updateForm.file) {
        // 把文件放入FormData
        let fd = new FormData();
        fd.append("file", this.updateForm.file);
        fd.append("name", this.updateForm.name)
        fd.append('imei', this.$route.query.id)
        fd.append('volume', this.updateForm.volume)
        fd.append('count', this.updateForm.count)
        fd.append('weeks', this.newWeek)
        fd.append('type', this.updateForm.type)
        fd.append('beginDate', this.beginDate)
        fd.append('finishDate', this.finishDate)
        fd.append('id', this.updateForm.id)
        fd.append('content', this.updateForm.content)
        fd.append('playTag', this.updateForm.playTag)
        fd.append('per', this.updateForm.per)
        myHttp.updateBroadcastTask(fd).then(resp => {
          console.log(resp);
          if (resp.data.code == '200') {
            this.$message({
              message: '修改任务成功',
              type: 'success'
            })
            this.$refs.clearfile2.value = null
            this.updateDialogVisible = false
            this.getbroadcastTask();
          } else {
            this.$message({
              message: resp.data.msg,
              type: 'error'
            })
          }
        })
        // } else {
        //   this.$message({
        //     message: '请选择文件',
        //     type: 'error'
        //   })
        // }
      },
      inputFileChange2(e) {
        // input的@change事件拿到数据        
        this.updateForm.file = e.target.files[0]
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.weeks.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.weeks.length;
        let newk = []
        value.forEach(item => {
          if (item == '星期一') {
            newk.push('1')
          } if (item == '星期二') {
            newk.push('2')
          } if (item == '星期三') {
            newk.push('3')
          } if (item == '星期四') {
            newk.push('4')
          } if (item == '星期五') {
            newk.push('5')
          } if (item == '星期六') {
            newk.push('6')
          } if (item == '星期日') {
            newk.push('7')
          }
        })
        if (newk.length == 7) {
          this.newWeek = 0
        } else {
          this.newWeek = newk.join(',')
        }
      },
      inputFileRealTimeChange(e) {
        this.realTimeForm.file = e.target.files[0]
      },
      // 增加实时播放
      addRealTime() {
        let fd = new FormData();
        fd.append('imei', this.$route.query.id)
        fd.append('volume', this.realTimeForm.volume)
        fd.append('count', this.realTimeForm.count)
        fd.append('file', this.realTimeForm.file)
        fd.append('playTag', this.realTimeForm.playTag)
        fd.append('per', this.realTimeForm.per)
        fd.append('content', this.realTimeForm.content)
        console.log(fd);
        myHttp.playbackAudio(fd).then(resp => {
          console.log(resp);
          if (resp.data.code == '200') {
            this.$message({
              message: '添加实时播放成功',
              type: 'success'
            })
            this.openRealTimeDialog = false
            this.getbroadcastTask()
          } else {
            this.$message({
              message: resp.data.msg,
              type: 'error'
            })
          }
        })
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getbroadcastTask();
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getbroadcastTask();
      }
    },
    computed: {
      indexMethod() {
        return (this.pageNum - 1) * this.pageSize + 1
      }
    }
  }
</script>
<style scoped>
  /deep/ .el-form-item__content {
    text-align: left;
  }

  /deep/ .el-form-item__label {
    padding: 0 1vw 0 0;
  }

  @import '../assets/css/common.css';
</style>